// extracted by mini-css-extract-plugin
export default {"appContainer":"src_appContainer__ySxmb"};